module.exports = __webpack_public_path__ + "static/media/gym-marker.ef6040a2.svg";